var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaitingforApproval(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1974_718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3025 6.2417V8.75019H19.8108L17.3025 6.2417Z",
    fill: "#41A041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8901 9.575C16.6623 9.575 16.4776 9.39031 16.4776 9.1625V6H10.5651C9.88278 6 9.32764 6.55514 9.32764 7.2375V11.8489C9.46354 11.8366 9.60107 11.83 9.74014 11.83C11.1462 11.83 12.4048 12.4728 13.2378 13.48H17.7151C17.9429 13.48 18.1276 13.6647 18.1276 13.8925C18.1276 14.1203 17.9429 14.305 17.7151 14.305H13.7812C14.0448 14.8193 14.2069 15.3795 14.2587 15.955H17.7151C17.9429 15.955 18.1276 16.1397 18.1276 16.3675C18.1276 16.5953 17.9429 16.78 17.7151 16.78H14.2587C14.1353 18.1423 13.4075 19.3327 12.346 20.08H18.8151C19.4975 20.08 20.0526 19.5249 20.0526 18.8425V9.575H16.8901ZM17.7151 11.83H11.6651C11.4373 11.83 11.2526 11.6453 11.2526 11.4175C11.2526 11.1897 11.4373 11.005 11.6651 11.005H17.7151C17.9429 11.005 18.1276 11.1897 18.1276 11.4175C18.1276 11.6453 17.9429 11.83 17.7151 11.83Z",
    fill: "#41A041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74009 12.6548C7.69302 12.6548 6.02759 14.3202 6.02759 16.3673C6.02759 18.4144 7.69302 20.0798 9.74009 20.0798C11.7872 20.0798 13.4526 18.4144 13.4526 16.3673C13.4526 14.3202 11.7872 12.6548 9.74009 12.6548ZM10.8401 16.7798H9.74009C9.51228 16.7798 9.32759 16.5951 9.32759 16.3673V14.7173C9.32759 14.4895 9.51228 14.3048 9.74009 14.3048C9.9679 14.3048 10.1526 14.4895 10.1526 14.7173V15.9548H10.8401C11.0679 15.9548 11.2526 16.1395 11.2526 16.3673C11.2526 16.5951 11.0679 16.7798 10.8401 16.7798Z",
    fill: "#41A041"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1974_718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.08,
    height: 14.08,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingforApproval);
export default __webpack_public_path__ + "static/media/Waiting for Approval.5f74e12c691f2bac57791cc27f9167e7.svg";
export { ForwardRef as ReactComponent };